<app-modal
  #modalRef
  [title]="'Versie ' + $safeNavigationMigration(popupReleaseNote()?.version)"
  [width]="'500px'"
  (closed)="closeReleaseNoteModal()"
>
  <div
    class="modal-body release-note-max-height"
    [innerHTML]="$safeNavigationMigration(popupReleaseNote()?.description)"
  ></div>
  <ndw-card-footer class="modal-footer">
    <button type="button" ndwButton alternative secondary (click)="closeReleaseNoteModal()">
      Sluit bericht
    </button>
    <button type="button" ndwButton (click)="completeReleaseNote()">Bekijk volledig bericht</button>
  </ndw-card-footer>
</app-modal>
